export enum ParameterType {
    TIME_PER_ROUND = 0,
    PERCENTAGES = 1,
    ENTRY_FEE = 2,
    ODDS = 3,
    DISCOUNTS = 4,
    POT_ALLOCATIONS = 5,
    STAKE_REQUIREMENTS = 6
}

export const ALL_PARAMETER_TYPES = [
    ParameterType.TIME_PER_ROUND,
    ParameterType.PERCENTAGES,
    ParameterType.ENTRY_FEE,
    ParameterType.ODDS,
    ParameterType.DISCOUNTS,
    ParameterType.POT_ALLOCATIONS,
    ParameterType.STAKE_REQUIREMENTS
]

export type BlockPotParameter = {
    name: string,
    type: ParameterType
}

export type ParameterConfig = {
    name: string
    description: string
    type: ParameterType
}